import {bigeshop, elearnapp, contactManager, smallshop, socialnetwork, tourwebsite, storeapp} from "../assets/projects";

export const projects = [
     {
        title: "StoreApp",
        image: storeapp,
        websitelink: "https://storeapp.ahmohazab.com/browser/",
        githublink: "https://github.com/amirmohazzab/StoreApp",
        info: "Asp.Net Api, Sql Server, Angular, Html, Css, Bootstrap"
    }, 
    {
        title: "BigEshop",
        image: bigeshop,
        websitelink: "https://bigeshop.ahmohazab.com",
        githublink: "https://github.com/amirmohazzab/BigEshop",
        info: "Asp.Net MVC, Sql Server, Html, Css, Bootstrap"
    }, 
    {
        title: "E-Learning Shop",
        image: elearnapp,
        websitelink: "https://elearnapp.ahmohazzab.com",
        githublink: "https://github.com/amirmohazzab/e-learning",
        info: "React, Nodejs, Redux-toolkit, MongoDB, TypeScript, Bootstrap"
    }, 
    {
        title: "Social network",
        image: socialnetwork,
        websitelink: "https://socialnetwork.ahmohazzab.com",
        githublink: "https://github.com/amirmohazzab/socialnetwork",
        info: "React, Nodejs, MongoDB, Mongoose, Context, Bulma-CSS"
    },
    {
        title: "Smallshop",
        image: smallshop,
        websitelink: "https://smallshop.ahmohazzab.com",
        githublink: "https://github.com/amirmohazzab/smallshop-app",
        info: "React, CSS"
    },
    {
        title: "Contact-Manager",
        image: contactManager,
        websitelink: "https://contacts.ahmohazzab.com",
        githublink: "https://github.com/amirmohazzab/contact-manager",
        info: "React, Context, Bootstrap"
    },
    {
        title: "TravelWebsite",
        image: tourwebsite,
        websitelink: "https://tourwebsite-amirmohazzab.netlify.app",
        githublink: "https://github.com/amirmohazzab/tourwebsite",
        info: "React, Tailwind Css, Context"
    },
]